import script from "./Live2D.vue?vue&type=script&setup=true&lang=js"
export * from "./Live2D.vue?vue&type=script&setup=true&lang=js"

import "./Live2D.vue?vue&type=style&index=0&id=0323badc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0323badc"]])

export default __exports__